import { ExperimentRunner, TrialScoreManager } from '@playcastdotio/PeerCore';
import type { ExperimentRunnerOptions, IExperimentRunner, TuningExperimentRequest,
  TuningExperimentSnapshot } from '@playcastdotio/PeerCore';

/** Application composition for the host-owned runner; no second sender or stats owner. */
export class HostExperimentManager implements IExperimentRunner {
  private readonly runner: ExperimentRunner;
  constructor(options: Omit<ExperimentRunnerOptions, 'scorer'> & { scorer?: ExperimentRunnerOptions['scorer'] }) {
    this.runner = new ExperimentRunner({ ...options, scorer: options.scorer ?? new TrialScoreManager() });
  }
  public start(request: TuningExperimentRequest): Promise<TuningExperimentSnapshot> { return this.runner.start(request); }
  public status(id: string): TuningExperimentSnapshot | undefined { return this.runner.status(id); }
  public cancel(id: string, reason: string): Promise<TuningExperimentSnapshot> { return this.runner.cancel(id, reason); }
  public register(host: { registerExperimentRunner(runner: IExperimentRunner): void }): void { host.registerExperimentRunner(this); }
}
